<template>
  <div class="about">
    <div class="imgbg"></div>
    <!-- 启动页 -->
    <h1><div></div></h1>
    <p>持续创新，量身打造</p>
  </div>
</template>
<script>
export default {
  name: 'Launch',
  mounted: function () {
    let str = window.location.href.split('?')[1]
    // let loginToken = localStorage.getItem('loginToken')
    // let loginDevicetype = localStorage.getItem('loginDevicetype')
    // console.log(loginToken)
    // console.log(loginDevicetype)
    // if (loginToken != null && loginDevicetype != null) {
    //   localStorage.setItem('loginToken', loginToken) // 存储
    //   localStorage.setItem('loginDevicetype', loginDevicetype) // 存储
    // } else {
    // alert(str)
    if (str != null) {
      let tokenStr = str.split('&')[0]
      // alert(tokenStr)
      // let devicetypeStr = str.split('&')[1]//devicetype=android#/login
      let devicetypeStr = str.split('&')[1].split('#')[0]// devicetype=android#/login
      // alert(devicetypeStr)
      if (tokenStr != null) {
        let token = tokenStr.split('=')[1]
        localStorage.setItem('loginToken', token) // 存储

        // alert(this.token)
      }
      if (devicetypeStr != null) {
        let devicetype = devicetypeStr.split('=')[1]
        localStorage.setItem('loginDevicetype', devicetype) // 存储

        // alert(this.devicetype)
      }
      // console.log(loginToken)
      // console.log(loginDevicetype)
    }
    // }
    setTimeout(() => {
      this.toLogin()
    }, 3000)
  },
  data () {
    return {
      isActive1: true,
      isActive2: true
    }
  },
  methods: {
    toLogin () {
      // console.log(localStorage.getItem('phoneNum'))
      // console.log(localStorage.getItem('passWord'))
      // console.log(localStorage.getItem('loginToken'))
      // console.log(localStorage.getItem('loginDevicetype'))
      let phoneNum = localStorage.getItem('phoneNum') // 存储手机号
      let passWord = localStorage.getItem('passWord') // 存储密码
      let loginToken = localStorage.getItem('loginToken')
      let loginDevicetype = localStorage.getItem('loginDevicetype')
      if (phoneNum && passWord && loginToken && loginDevicetype) {
        // 请求验证接口：
        this.util.post('/login', {
          phoneNum: phoneNum,
          passWord: passWord,
          token: loginToken,
          devicetype: loginDevicetype,
          type:1
        }).then(({ data }) => {
          if (data.code === 200) {
          // 登录按钮执行登录的时候，存localStorage
            localStorage.setItem('isLogin', 1) // 存储已登录信息
            localStorage.setItem('UserToken', data.data.UserToken)

            // localStorage.setItem('phoneNum', phoneNum) // 存储手机号
            // localStorage.setItem('passWord', passWord) // 存储密码
            if (data.data.status === 1) {
              // 不是第一次登录，跳转到主页
              this.$router.replace({
                path: '/home',// 进入主页
                query:{date:new Date().getTime()}
              })
            } else {
              // 验证成，跳转首页
              this.$router.replace({
                path: '/guide'// 进入引导页
              })
            }
          } else {
            // 验证失败
            this.$router.replace('/login')// 跳转到登录页
            // return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
          }
        })
      } else {
        this.$router.replace('/login')// 跳转到登录页
      }
    }
  }
}
</script>
<style lang="less">
.about {
  .imgbg{
    width: 100vw;
    height: 100vh;
    background: url(../assets/qdy@3x.png) no-repeat center top;
    background-size: cover;
    -webkit-animation-name:scaleDraw;
    -webkit-animation-timing-function:ease-in-out;
    -webkit-animation-iteration-count:infinite;
    -webkit-animation-duration:3s;
  }

  h1 {
    width: 100vw;
    position: absolute;
    top: 30vh;
    z-index: 2;
    // border: 1px solid red;
    div{
      width: 75px;
      height: 75px;
      background: url(../assets/px-fanbai.png) no-repeat right top;
      background-size: 100% 100%;
      margin: 0 auto;
      // border: 1px solid red;

    }
  }
  p{
    width: 100%;
    text-align: center;
    color: #EFF7FA;
    position: absolute;
    bottom: 5vh;
    z-index: 2;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
@keyframes scaleDraw {
    0% {
      transform:scale(1);
    }
    50% {
      transform:scale(1);
    }
    100% {
      transform:scale(1.2);
    }
 }
</style>
